import React, { useEffect, useState } from 'react';
import {
    adminGetBonusTiers, adminCreateBonusTier, adminUpdateBonusTier, adminDeleteBonusTier,
    adminCreditAll,
} from '../../api';

const s = {
    h1:    { fontSize: 22, fontWeight: 700, marginBottom: 6 },
    sub:   { fontSize: 13, color: '#6b7280', marginBottom: 28 },
    grid:  { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'start' },
    box:   { background: '#fff', borderRadius: 10, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,.06)' },
    boxH:  { fontSize: 15, fontWeight: 700, marginBottom: 4, color: '#1a1d23' },
    boxS:  { fontSize: 12, color: '#6b7280', marginBottom: 18 },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
    th:    { textAlign: 'left', padding: '10px 14px', background: '#f9fafb', borderBottom: '2px solid #f3f4f6', color: '#6b7280', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5 },
    td:    { padding: '11px 14px', borderBottom: '1px solid #f9fafb', verticalAlign: 'middle' },
    btn:   { padding: '6px 14px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 600 },
    lbl:   { display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, marginTop: 12 },
    inp:   { width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' },
    sel:   { width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff', boxSizing: 'border-box' },
    row:   { display: 'flex', gap: 10, marginTop: 16 },
    alert: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginTop: 12 },
};

const BADGE_ACTIVE = { display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: '#d1fae5', color: '#065f46' };
const BADGE_OFF    = { ...BADGE_ACTIVE, background: '#f3f4f6', color: '#6b7280' };

export default function AdminBonuses() {
    const [tiers, setTiers]       = useState([]);
    const [loading, setLoading]   = useState(true);
    const [form, setForm]         = useState({ min_amount: '', bonus_pct: '', label: '' });
    const [saving, setSaving]     = useState(false);
    const [msg, setMsg]           = useState(null); // { type: 'ok'|'err', text }

    // Bulk credit state
    const [creditAmt,  setCreditAmt]  = useState('');
    const [creditType, setCreditType] = useState('flat');
    const [crediting,  setCrediting]  = useState(false);
    const [creditMsg,  setCreditMsg]  = useState(null);

    const load = () => {
        setLoading(true);
        adminGetBonusTiers().then(r => setTiers(r.data)).catch(() => {}).finally(() => setLoading(false));
    };
    useEffect(load, []);

    const flash = (type, text) => { setMsg({ type, text }); setTimeout(() => setMsg(null), 3500); };
    const flashCredit = (type, text) => { setCreditMsg({ type, text }); setTimeout(() => setCreditMsg(null), 4000); };

    const addTier = async () => {
        if (!form.min_amount || !form.bonus_pct) { flash('err', 'Compila importo minimo e bonus %'); return; }
        setSaving(true);
        try {
            await adminCreateBonusTier({ min_amount: form.min_amount, bonus_pct: form.bonus_pct, label: form.label });
            setForm({ min_amount: '', bonus_pct: '', label: '' });
            flash('ok', 'Tier aggiunto');
            load();
        } catch (e) {
            flash('err', e.response?.data?.error || 'Errore');
        } finally { setSaving(false); }
    };

    const toggleActive = async (tier) => {
        await adminUpdateBonusTier(tier.id, { is_active: !tier.is_active });
        load();
    };

    const deleteTier = async (id) => {
        if (!window.confirm('Eliminare questo tier?')) return;
        await adminDeleteBonusTier(id);
        load();
    };

    const doCreditAll = async () => {
        const val = parseFloat(creditAmt);
        if (!val || val <= 0) { flashCredit('err', 'Inserisci un importo valido'); return; }
        const label = creditType === 'flat'
            ? `€${val} a ogni utente attivo`
            : `${val}% del saldo a ogni utente attivo`;
        if (!window.confirm(`Confermi? Aggiungerà ${label}.\nQuesta azione è irreversibile.`)) return;
        setCrediting(true);
        try {
            const r = await adminCreditAll(val, creditType);
            flashCredit('ok', `✅ Credito aggiunto a ${r.data.clients_credited} utenti`);
            setCreditAmt('');
        } catch (e) {
            flashCredit('err', e.response?.data?.error || 'Errore');
        } finally { setCrediting(false); }
    };

    return (
        <div>
            <h1 style={s.h1}>Bonus & Crediti</h1>
            <p style={s.sub}>Gestisci i bonus automatici sui depositi e aggiungi credito manualmente agli utenti.</p>

            <div style={s.grid}>
                {/* ── Bonus tiers ── */}
                <div style={s.box}>
                    <div style={s.boxH}>🎁 Bonus automatici deposito</div>
                    <p style={s.boxS}>Quando un utente deposita almeno X€, riceve automaticamente un bonus % aggiuntivo accreditato subito.</p>

                    {loading ? (
                        <p style={{ color: '#9ca3af', fontSize: 13 }}>Caricamento...</p>
                    ) : tiers.length === 0 ? (
                        <p style={{ color: '#9ca3af', fontSize: 13 }}>Nessun tier configurato.</p>
                    ) : (
                        <div className="og-table-wrap">
                        <table style={s.table}>
                            <thead>
                                <tr>
                                    {['Min deposito', 'Bonus', 'Label', 'Stato', 'Azioni'].map(h => (
                                        <th key={h} style={s.th}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {tiers.map(t => (
                                    <tr key={t.id}>
                                        <td style={{ ...s.td, fontWeight: 700 }}>€{parseFloat(t.min_amount).toFixed(0)}</td>
                                        <td style={{ ...s.td, color: '#1d4ed8', fontWeight: 700 }}>+{t.bonus_pct}%</td>
                                        <td style={{ ...s.td, color: '#6b7280' }}>{t.label || '—'}</td>
                                        <td style={s.td}>
                                            <span style={t.is_active ? BADGE_ACTIVE : BADGE_OFF}>
                                                {t.is_active ? 'Attivo' : 'Disattivo'}
                                            </span>
                                        </td>
                                        <td style={s.td}>
                                            <div style={{ display: 'flex', gap: 6 }}>
                                                <button
                                                    style={{ ...s.btn, background: t.is_active ? '#fef3c7' : '#d1fae5', color: t.is_active ? '#92400e' : '#065f46' }}
                                                    onClick={() => toggleActive(t)}
                                                >
                                                    {t.is_active ? 'Pausa' : 'Attiva'}
                                                </button>
                                                <button
                                                    style={{ ...s.btn, background: '#fee2e2', color: '#991b1b' }}
                                                    onClick={() => deleteTier(t.id)}
                                                >
                                                    Elimina
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    )}

                    {/* Add new tier */}
                    <div style={{ marginTop: 20, paddingTop: 18, borderTop: '1px solid #f3f4f6' }}>
                        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: '#374151' }}>Aggiungi tier</div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                            <div>
                                <label style={s.lbl}>Deposito minimo (€)</label>
                                <input style={s.inp} type="number" min="1" step="1" placeholder="es. 500"
                                    value={form.min_amount} onChange={e => setForm(f => ({ ...f, min_amount: e.target.value }))} />
                            </div>
                            <div>
                                <label style={s.lbl}>Bonus %</label>
                                <input style={s.inp} type="number" min="1" max="100" step="1" placeholder="es. 5"
                                    value={form.bonus_pct} onChange={e => setForm(f => ({ ...f, bonus_pct: e.target.value }))} />
                            </div>
                        </div>
                        <label style={s.lbl}>Label (opzionale)</label>
                        <input style={s.inp} type="text" placeholder="es. Gold Bonus"
                            value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))} />

                        {msg && (
                            <div style={{ ...s.alert, background: msg.type === 'ok' ? '#d1fae5' : '#fee2e2', color: msg.type === 'ok' ? '#065f46' : '#991b1b' }}>
                                {msg.text}
                            </div>
                        )}

                        <button
                            onClick={addTier}
                            disabled={saving}
                            style={{ ...s.btn, background: '#1d4ed8', color: '#fff', marginTop: 14, padding: '9px 20px', fontSize: 13 }}
                        >
                            {saving ? 'Salvataggio...' : '+ Aggiungi tier'}
                        </button>
                    </div>
                </div>

                {/* ── Bulk credit ── */}
                <div style={s.box}>
                    <div style={s.boxH}>💰 Aggiungi credito agli utenti</div>
                    <p style={s.boxS}>Aggiungi un importo fisso o percentuale a tutti gli utenti attivi contemporaneamente. Utile per promozioni, offerte speciali o compensazioni.</p>

                    <label style={s.lbl}>Tipo di credito</label>
                    <select style={s.sel} value={creditType} onChange={e => setCreditType(e.target.value)}>
                        <option value="flat">Importo fisso (€ per utente)</option>
                        <option value="pct">Percentuale del saldo corrente (%)</option>
                    </select>

                    <label style={s.lbl}>
                        {creditType === 'flat' ? 'Importo in € (per ogni utente)' : 'Percentuale %'}
                    </label>
                    <input
                        style={s.inp}
                        type="number"
                        min="0.01"
                        step={creditType === 'flat' ? '0.01' : '0.1'}
                        placeholder={creditType === 'flat' ? 'es. 5.00' : 'es. 10'}
                        value={creditAmt}
                        onChange={e => setCreditAmt(e.target.value)}
                    />

                    {/* Preview */}
                    {creditAmt && parseFloat(creditAmt) > 0 && (
                        <div style={{ marginTop: 12, padding: '10px 14px', background: '#eff6ff', borderRadius: 8, fontSize: 13, color: '#1e40af' }}>
                            {creditType === 'flat'
                                ? <>Ogni utente attivo riceverà <strong>+€{parseFloat(creditAmt).toFixed(2)}</strong></>
                                : <>Ogni utente attivo riceverà <strong>+{parseFloat(creditAmt)}%</strong> del suo saldo attuale</>
                            }
                        </div>
                    )}

                    {creditMsg && (
                        <div style={{ ...s.alert, background: creditMsg.type === 'ok' ? '#d1fae5' : '#fee2e2', color: creditMsg.type === 'ok' ? '#065f46' : '#991b1b' }}>
                            {creditMsg.text}
                        </div>
                    )}

                    <button
                        onClick={doCreditAll}
                        disabled={crediting}
                        style={{ ...s.btn, background: '#059669', color: '#fff', marginTop: 16, padding: '11px 0', width: '100%', fontSize: 14 }}
                    >
                        {crediting ? 'Accreditamento in corso...' : '💰 Accredita a tutti gli utenti'}
                    </button>

                    <div style={{ marginTop: 14, padding: '12px 14px', background: '#fef3c7', borderRadius: 8, fontSize: 12, color: '#92400e', lineHeight: 1.6 }}>
                        ⚠️ <strong>Attenzione</strong>: questa operazione aggiunge credito a <strong>tutti</strong> gli utenti attivi e non è reversibile. Usa con cautela.
                    </div>
                </div>
            </div>
        </div>
    );
}
